<div class="modal-header">
  <h4 class="modal-title">{{ titulo }}</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <div class="container">
          <div class="row">
            <div class="col-md-6 offset-md-3">
              <span>Seleccione una Foto</span>
              <div class="form-group">
                <div class="holder">
                  <input
                    type="file"
                    name="image"
                    (change)="fileProgress($event)"
                  />
                </div>
              </div>
              <!-- Progress Bar -->
              <div class="progress form-group" *ngIf="progress > 0">
                <div
                  class="progress-bar progress-bar-striped bg-success"
                  role="progressbar"
                  [style.width.%]="progress"
                ></div>
              </div>

              <div *ngIf="fileUploadProgress">
                progreso: {{ fileUploadProgress }}
              </div>
              <div class="image-preview mb-3" *ngIf="previewUrl">
                <img [src]="previewUrl" height="300" />
              </div>

              <div class="mb-3" *ngIf="uploadedFilePath">
                {{ uploadedFilePath }}
              </div>

              <!--   <div class="form-group">
                    <button class="btn btn-primary" (click)="subirFoto()">
                      Subir la servidor
                    </button>
                  </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <form
        action=""
        [formGroup]="productsForm"
        (ngSubmit)="registerProducts()"
        class="form-horizontal form-material"
        id="productform"
        novalidate
      >
        <div class="form-group  row m-t-20">
          <div class="col-xs-12 col-md-12 ">
            <app-form-error-wrapper
              [control]="productsForm.controls['categoria']"
              [controlName]="'Categoría'"
            >
              <label for="inputGroupSelect02">Categoría</label>
              <select
                class="custom-select"
                id="inputGroupSelect02"
                formControlName="categoria"
              >
                <option value="">Seleccione Categorías</option>
                <option
                  *ngFor="let category of categories"
                  [ngValue]="category.categoria_id"
                >
                  {{ category.nombre }}</option
                >
              </select>
            </app-form-error-wrapper>
          </div>
        </div>
        <div class="form-group row m-t-20">
          <div class="col-xs-12 col-md-12">
            <app-form-error-wrapper
              [control]="productsForm.controls['nombre']"
              [controlName]="'Nombre'"
            >
              <label for="nombre">Nombre del Producto</label>
              <input
                class="form-control"
                type="text"
                id="nombre"
                formControlName="nombre"
                placeholder="Nombre de producto"
              />
            </app-form-error-wrapper>
          </div>
        </div>
        <div class="form-group row  m-t-20">
          <div class="col-xs-12  col-md-12 ">
            <app-form-error-wrapper
              [control]="productsForm.controls['descripcion']"
              [controlName]="'Descrpción'"
            >
              <label for="descripcion">Descripción</label>
              <input
                class="form-control"
                type="text"
                id="descripcion"
                formControlName="descripcion"
                placeholder="Descripción"
              />
            </app-form-error-wrapper>
          </div>
        </div>
        <div class="form-group  row m-t-20">
          <div class="col-xs-12 col-md-6">
            <app-form-error-wrapper
              [control]="productsForm.controls['marca']"
              [controlName]="'Nombre de marca '"
            >
              <label for="marca">Marca</label>
              <input
                class="form-control"
                type="text"
                id="marca"
                formControlName="marca"
                placeholder="Nombre de marca "
              />
            </app-form-error-wrapper>
          </div>
          <div class="col-xs-12 col-md-3">
            <app-form-error-wrapper
              [control]="productsForm.controls['codigo']"
              [controlName]="'Codigo'"
            >
              <label for="codigo">Código</label>
              <input
                class="form-control"
                type="text"
                id="codigo"
                formControlName="codigo"
                placeholder="Codigo"
              />
            </app-form-error-wrapper>
          </div>
          <div class="col-xs-12 col-md-3">
            <app-form-error-wrapper
              [control]="productsForm.controls['precio_venta']"
              [controlName]="'Precio de Venta'"
            >
              <label for="codigo">Precio Venta</label>
              <input
                class="form-control"
                type="text"
                id="codigo"
                formControlName="precio_venta"
                placeholder="Precio Venta"
              />
            </app-form-error-wrapper>
          </div>
        </div>
        <div class="form-group row m-t-20">
          <div class="col-xs-12 col-md-6">
            <app-form-error-wrapper
              [control]="productsForm.controls['unidad']"
              [controlName]="'Unidad'"
            >
              <label for="unidad">Unidad</label>
              <select
                class="custom-select"
                id="inputGroupSelect02"
                formControlName="unidad"
              >
                <option value="">Seleccione Unidad</option>
                <option
                  *ngFor="let unidad of unidades"
                  [ngValue]="unidad.unidad_id"
                >
                  {{ unidad.nombre }}</option
                >
              </select>
              <!--  <input
                      class="form-control"
                      type="text"
                      id="unidad"
                      formControlName="unidad"
                      placeholder="Unidad "
                    />-->
            </app-form-error-wrapper>
          </div>
          <div class="col-xs-6 col-md-3">
            <app-form-error-wrapper
              [control]="productsForm.controls['limite_a']"
              [controlName]="'Limite Amarillo'"
            >
              <label for="abre">E. Media</label>
              <input
                class="form-control"
                type="text"
                id="abre"
                formControlName="limite_a"
                placeholder="E. Media"
              />
            </app-form-error-wrapper>
          </div>
          <div class="col-xs-6 col-md-3">
            <app-form-error-wrapper
              [control]="productsForm.controls['limite_r']"
              [controlName]="'Limite Rojo'"
            >
              <label for="abre">E. Minima</label>
              <input
                class="form-control"
                type="text"
                id="abre"
                formControlName="limite_r"
                placeholder="E. Minima"
              />
            </app-form-error-wrapper>
          </div>
          <!--                  <div class="col-xs-12 col-md-6">
                                  <app-form-error-wrapper
                                    [control]="productsForm.controls['stock']"
                                    [controlName]="'Stock'"
                                  >
                                    <label for="stock">Stck</label>
                                    <input
                                      class="form-control"
                                      type="text"
                                      id="stock"
                                      formControlName="stock"
                                      placeholder="stock"
                                    />
                                  </app-form-error-wrapper>
                                </div>-->
        </div>

        <div class="form-group  row m-t-20">
          <!--                  <div class="col-xs-12 col-md-12 ">-->
          <!--                    <div class="custom-file">-->
          <!--                      <app-form-error-wrapper-->
          <!--                        [control]="productsForm.controls['foto']"-->
          <!--                        [controlName]="'Foto'"-->
          <!--                      >-->
          <!--                        <input-->
          <!--                          type="file"-->
          <!--                          class="custom-file-input"-->
          <!--                          id="customFileLangHTML"-->
          <!--                          formControlName="foto"-->
          <!--                        />-->
          <!--                        <label-->
          <!--                          class="custom-file-label"-->
          <!--                          for="customFileLangHTML"-->
          <!--                          data-browse="Elegir"-->
          <!--                          >Seleccione</label-->
          <!--                        >-->
          <!--                      </app-form-error-wrapper>-->
          <!--                    </div>-->
          <!--                  </div>-->
        </div>
        <div class="form-group text-center m-t-20">
          <div class="col-xs-12">
            <button
              class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
              [disabled]="productsForm.invalid || isLoading"
            >
              <app-button-loader
                [isLoading]="isLoading"
                [label]="'GUARDAR'"
              ></app-button-loader>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
